import { render, staticRenderFns } from "./AlignmentSettings.vue?vue&type=template&id=b4a3e708"
import script from "./AlignmentSettings.vue?vue&type=script&lang=js"
export * from "./AlignmentSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports